<template lang="pug">
v-card
    v-card-title Notification UI Settings
        v-spacer
    v-card-text
        v-data-table(
            :headers="headers"
            :loading="isLoading"
            loading-text="Fetching Data..."
            :items="isLoading ? [] : desserts"
            single-expand
            show-expand
        )
            template(v-slot:item.items="{ item }")
                v-chip(x-small v-if="!item.values" class="ma-2" color="grey" text-color="white") All
                v-chip(x-small v-else v-for="(item, index) in item.values" class="ma-2" color="green" text-color="white") {{ templateName(item) }}

            template(v-slot:expanded-item="{ item }")
                td(:colspan="headers.length")
                    v-row
                        v-col(align="end")
                            NotificationUIManagerVue(
                                v-if="!!item.values"
                                :values="item.values"
                                :templates="filterSelections"
                                @change="function(data) { updateItem(item.name, data) }"
                            )
</template>
<script>
import { mapActions } from 'vuex';
import NotificationUIManagerVue from './NotificationUIManager.vue';

export default {
    data() {
        return {
            isLoading: false,
            settingsId: null,
            desserts: [],
            filterSelections: [],
            headers: [
                {
                    text: 'Tab Name',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'Notification Items',
                    align: 'start',
                    sortable: false,
                    value: 'items'
                },
                {
                    text: 'Actions',
                    align: 'end',
                    value: 'data-table-expand'
                }
            ]
        };
    },
    created() {
        this.isLoading = true;

        this.getAllTemplates({
            query: { $limit: -1 }
        }).then(items => {
            this.filterSelections = items.filter(i => !!i.hook).map(item => {
                console.log(item);
                return {
                    id: item.id,
                    name: `${item.name} - ${item.target_type}`,
                    service: item.hook.service
                };
            });
        }).then((_) => {
            return this.getSettings({query: {
                option_name: 'notification_tabs'
            }}).then((result) => {
                if(result.data.length !== 0) {
                    this.settingsId = result.data[0].id;
                    this.desserts = JSON.parse(result.data[0].option_value).map((item, index) => {
                        return {
                            id: index,
                            ...item
                        };
                    });
                }
            });
        }).finally(() => this.isLoading = false);
    },
    computed: {
        
    },
    methods: {
        updateItem(name, values) {
            this.desserts.map(item => {
                if(item.name === name) {
                    item.values = values;
                }
            });
            this.updateSettings([this.settingsId, {
                option_value: JSON.stringify(this.desserts)
            }]);
        },
        templateName(value) {
            return this.filterSelections.filter(item => item.id === parseInt(value))[0].name;
        },
        ...mapActions('bh-notification-templates', { getAllTemplates: 'find' }),
        ...mapActions('bh-settings', { getSettings: 'find', updateSettings: 'patch' })
    },
    components: {
        NotificationUIManagerVue
    }
};
</script>